import { Component, Inject, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Router } from '@angular/router'
import { Subject, takeUntil } from 'rxjs'
import { AyBService } from 'src/app/services/api/ayb.service'
import Swal from 'sweetalert2'
import { FormIngresoService } from '../../../services/forms/form-ingreso.service'
@Component({
  selector: 'app-dialog-inventario-menajeria',
  templateUrl: './dialog-inventario-menajeria.component.html',
  styleUrls: ['./dialog-inventario-menajeria.component.scss']
})
export class DialogInventarioMenajeriaComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$: Subject<boolean> = new Subject<boolean>()
  estado: any
  menajeriaId: any

  menajeriaForm
  constructor (
    private router: Router,
    private fb: FormBuilder,
    private readonly alimentosService: AyBService,
    private readonly formService: FormIngresoService,
    public dialogRef: MatDialogRef<DialogInventarioMenajeriaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.menajeriaForm = this.formService.getMenajeriaForm()
  }

  ngOnInit (): void {
    console.log(this.data)

    this.menajeriaForm.get(['nombre'])?.setValue(this.data.nombre)
    this.menajeriaForm.get(['marca'])?.setValue(this.data.marca)
    this.menajeriaForm.get(['modelo'])?.setValue(this.data.modelo)
    this.menajeriaForm.get(['cantidad'])?.setValue(this.data.cantidad)
    this.menajeriaForm
      .get(['factura', 'razonSocial'])
      ?.setValue(this.data?.razonSocial)
    this.menajeriaForm.get(['factura', 'ruc'])?.setValue(this.data.ruc)
    this.menajeriaForm
      .get(['factura', 'numFactura'])
      ?.setValue(this.data.numFactura)
    this.estado = this.data.estado
    this.menajeriaId = this.data.id
    console.log(this.estado)

    console.log(this.menajeriaForm)
  }

  ngOnDestroy (): void {
    this._unsubscribeOnDestroy$.next(true)
    this._unsubscribeOnDestroy$.complete()
  }

  createMenajeria () {
    this.alimentosService
      .mutationCreateMenajeria(this.menajeriaForm.value)
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe((data: any) => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Se agregó el artículo al almacén',
          showConfirmButton: false,
          timer: 4000
        })
        console.log('newMenajeria')
        console.log(data)
        this.dialogRef.close(1)
      })
  }

  updateMenajeria () {
    this.alimentosService
      .mutationUpdateMenajeria(this.menajeriaId, this.menajeriaForm.value)
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe((data: any) => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Se modificó el artículo',
          showConfirmButton: false,
          timer: 4000
        })
        console.log(data)
        this.dialogRef.close(1)
      })
  }
}
